export const MISCELLANEOUS_OPTIONS = {
  CURRENT_DATE: "CurrentDate",
  CURRENT_DATE_TIME: "CurrentDateTime",
};
export const MISCELLANEOUS_MENU_OPTIONS = {
  title: "Miscellaneous",
  menu: [
    {
      title: "Current Date",
      value: MISCELLANEOUS_OPTIONS.CURRENT_DATE,
    },
    {
      title: "Current Date Time",
      value: MISCELLANEOUS_OPTIONS.CURRENT_DATE_TIME,
    },
  ],
};
